import React from 'react';

import { Modal, ModalProps } from 'lighthouse';

const SwipeableDrawer = ({ container, PaperProps, ...restProps }: ModalProps) => {
    const innerAppEl = typeof window !== 'undefined' ? (document as Document)?.getElementById('inner-app') : null;
    const paperClassName = PaperProps?.className ?? '';
    const hasMaxWidthOverride = /\b(?:!)?(?:\w+:)*max-w-/.test(paperClassName);

    return (
        <Modal
            PaperProps={{
                ...PaperProps,
                className: `w-full mx-auto rounded-t-lg md:rounded-lg [@media(min-width:900px)_and_(max-width:960px)]:mb-0 ${
                    hasMaxWidthOverride ? '' : 'md:max-w-md'
                } ${paperClassName}`.trim()
            }}
            container={container || innerAppEl}
            {...restProps}></Modal>
    );
};

export default SwipeableDrawer;
